import React from 'react';

import { ShareButton } from '@confluence/share/entry-points/ShareButton';

export const InviteToEditButton = ({ buttonProps, title, contentId, contentType, intl }) => {
	const shareFormTitle = intl.formatMessage({
		id: 'editor.fabric.share.invite.to.edit.form.title',
	});
	const emptyTitle =
		contentType === 'blogpost'
			? intl.formatMessage({
					id: 'editor.fabric.share.invite.to.edit.empty.blog.post.title',
				})
			: intl.formatMessage({
					id: 'editor.fabric.share.invite.to.edit.empty.page.title',
				});

	return (
		<ShareButton
			contentId={contentId}
			shareFormTitle={shareFormTitle}
			shareTitle={title || emptyTitle}
			shareeAction="edit"
			showInviteToEditPlaceholder
			renderCustomTriggerButton={({ isSelected, onClick }: any, { ...triggerProps }): any => {
				return (
					<span {...triggerProps}>
						{React.cloneElement(buttonProps.children, {
							isSelected,
							onClick,
						})}
					</span>
				);
			}}
		/>
	);
};
